import React from 'react';
import { X, ScrollText } from 'lucide-react';
import { useChat } from '@/contexts/ChatContext';

interface ChatHeaderProps {
  onClose: () => void;
  onShowRules: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose, onShowRules }) => {
  const { onlineCount } = useChat();

  const formatCount = (count: number): string => {
    if (count >= 1000) {
      return (count / 1000).toFixed(count >= 10000 ? 0 : 1) + 'K';
    }
    return count.toLocaleString();
  };

  /* Desktop website header = <header border-b> + <div py-3> + 46px buttons.
     Rendered height: 12 + 46 + 12 = 70px content + 1px border = 71px.
     We match that exactly on lg with a fixed box-height. Mobile stays compact. */
  return (
    <div className="flex items-center justify-between px-3 h-[42px] lg:h-[71px] border-b border-border flex-shrink-0 bg-card">
      <span className="text-sm font-semibold text-foreground">Social Chat</span>

      <div className="flex items-center gap-2">
        {/* Online count */}
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
          </span>
          <span className="tabular-nums">{formatCount(onlineCount)}</span>
        </div>

        {/* Rules button */}
        <button
          onClick={onShowRules}
          className="text-muted-foreground hover:text-foreground transition-colors p-1 rounded"
          title="Chat Rules"
        >
          <ScrollText className="h-4 w-4" />
        </button>

        {/* Close button */}
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors p-1 rounded"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
